import React from 'react'
import { Statistic, Progress } from 'semantic-ui-react'

const yellow = '#ffe445'

export default class Timer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            startTime: 0,
            remainingTime: 0,
            intervalId: 0
        }
    }

    componentDidMount() {
        this.setState({ startTime: Date.now(), intervalId: setInterval(this.tick, 100) })
    }

    componentWillUnmount() {
        const { intervalId } = this.state
        if (intervalId)
            clearInterval(intervalId)
    }

    tick = () => {
        const { ms, onFinish } = this.props
        const elapsedTime = Date.now() - this.state.startTime
        const remainingTime = ms - elapsedTime
        if (remainingTime > 0) {
            this.setState({ remainingTime })
        } else {
            clearInterval(this.state.intervalId)
            this.setState({ remainingTime: 0 })
            if (onFinish)
                onFinish()
        }
    }

    render() {
        const { ms, isProgress } = this.props
        const { remainingTime } = this.state

        return (
            isProgress ?
                <Progress total={ms} value={remainingTime} attached='bottom' color='purple' /> :
                <Statistic>
                    <Statistic.Value><span style={{ color: yellow }}>{(this.state.remainingTime / 1000).toFixed(1)}</span> </Statistic.Value>
                    <Statistic.Label>Secondi</Statistic.Label>
                </Statistic>    
        )

        /*
            <Statistic>
              <Statistic.Value><span style={{ color: yellow }}>{(this.state.remainingTime / 1000).toFixed(1)}</span> </Statistic.Value>
              <Statistic.Label>Secondi</Statistic.Label>
            </Statistic>
            */
    }
}


// WEBPACK FOOTER //
// ./src/components/Timer.js